import React, { PureComponent } from 'react'
import { SIZES } from '../../../constants'
import FirstBox from './StyledFirstBox'
import SmallBox from './StyledSmallBox'
import ContainerRow from './StyledContainerRow'
import LeftColumn from './StyledLeftColumn'
import RightColumn from './StyledRightColumn'
import UTM from '../../utils/UTM'
import { type DynamicleadWidgetProps, type DynamicleadWidgetState } from './Types'

export default class Dynamiclead extends PureComponent<DynamicleadWidgetProps, DynamicleadWidgetState> {
  constructor (props) {
    super(props)

    this.state = {
      firstImageSize: this.calculateFirstImageSize()
    }
  }

  componentWillMount () {
    if (typeof window !== 'undefined') {
      window.onresize = () => {
        const {
          firstImageSize
        } = this.state

        const newSize = this.calculateFirstImageSize()

        if (firstImageSize !== newSize) {
          this.setState({
            firstImageSize: newSize
          })
        }
      }
    }
  }

  calculateFirstImageSize () {
    let size = '1_1L'

    if (typeof window !== 'undefined' && window.innerWidth < SIZES.BREAKPOINT_MD) {
      size = '4_3L'
    }

    return size
  }

  render () {
    const {
      widget: {
        boxes: originalBoxes,
        name,
        utmContent,
        utmMedium,
        utmSource,
        imageSize
      }
    } = this.props

    const {
      firstImageSize
    } = this.state

    if (!originalBoxes.length) return null

    const boxes = Object.assign([], originalBoxes)
    const firstBox = boxes.shift()

    const firstBoxImage = firstBox.images[firstImageSize]
    const firstBoxLink = new UTM(firstBox.link).getUTMLink({
      utmContent,
      utmMedium,
      utmSource,
      utmTerm: 'position-0',
      utmCampaign: firstBox.source
    })

    return (
      <ContainerRow id={name}>
        <LeftColumn>
          <FirstBox
            covered
            featuredSize='big'
            featuredType={firstBox.featuredType}
            image={firstBoxImage}
            imageClass={`image-${firstImageSize}`}
            isImage={true}
            key={firstBox.guid}
            link={firstBoxLink}
            title={firstBox.title}
          />
        </LeftColumn>
        <RightColumn>
          {
            boxes.map(box => {
              const {
                featuredType,
                guid,
                images,
                link,
                source,
                title
              } = box

              const utmLink = new UTM(link).getUTMLink({
                utmContent,
                utmMedium,
                utmSource,
                utmTerm: `position-${originalBoxes.indexOf(box)}`,
                utmCampaign: source
              })

              const image = images[imageSize]

              return (
                <SmallBox
                  featuredSize='small'
                  featuredType={featuredType}
                  image={image}
                  imageClass={`image-${imageSize}`}
                  isImage={true}
                  key={guid}
                  link={utmLink}
                  title={title}
                />
              )
            })
          }
        </RightColumn>
      </ContainerRow>
    )
  }
}
